



























import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { user } from '../fire'
import * as Interface from '../../functions/interfaces'



export default Vue.extend({
    mounted() {
        this.fetch()
    },
    data() {
        return {
            user: user,
            project_name: '',
            pledges: [] as Array<Interface.Pledge>
        }
    },
    methods: {
        fetch: async function() {
            
            // Id
            const id = this.$route.params.id
            if (id == null) return

            
            // Fetch
            try { 
                let db = firebase.firestore()


                // Project
                let project = await firebase.firestore().collection('projects').doc(id).get()
                this.project_name = project.data().name.hu


                // Pledges
                await db.collection('pledges').where('project_id', '==', id).onSnapshot(async (snap) => {
                    this.pledges = []
                    for (const doc of snap.docs) {
                        const pledge = doc.data()! as unknown as Interface.Pledge
                        if (pledge.status != 'FINISHED') continue
                        pledge.id = doc.id

                        let user = await db.collection('users').doc(pledge.user_id).get()
                        // @ts-ignore
                        pledge.user = user.data()
                        this.pledges.push(pledge)
                    }
                })
            }
            catch(error) { console.log('Unable to fetch event'), error; alert(error.message) }
        },
    }
})
